import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { ClockCircleOutlined, LoginOutlined } from '@ant-design/icons';

const SessionExpired: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'var(--color-primary)',
      padding: '20px'
    }}>
      <Result
        status="warning"
        title="Sesión Cerrada"
        style={{
          background: 'var(--bg-primary)',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px',
          boxShadow: '0 10px 40px var(--shadow-color)'
        }}
        subTitle={
          <div style={{ fontSize: '16px', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '16px' }}>
              Tu sesión fue cerrada porque iniciaste sesión en otro dispositivo.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Solo se permite una sesión activa por usuario.
            </p>
            <div style={{
              background: 'var(--bg-tertiary)',
              padding: '16px',
              borderRadius: '8px',
              marginTop: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px'
            }}>
              <ClockCircleOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                Redirigiendo en {countdown} segundo{countdown !== 1 ? 's' : ''}...
              </span>
            </div>
          </div>
        }
        extra={
          <Button
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            onClick={handleGoToLogin}
            style={{
              height: '48px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Ir al Login Ahora
          </Button>
        }
      />
    </div>
  );
};

export default SessionExpired;
